import React from "react";
import {SafeView, TabsContainer, Tabs} from "@onemind-services-llc/ui-components";
import CloudInstanceHeader from "./cloudInstanceHeader";
import tabList from "./cloudInstanceTabList";
import BreadCrumb from "../../../components/breadCrumb";

const CloudInstanceDetails = () => {
  return (
    <SafeView>
      <BreadCrumb />
      <CloudInstanceHeader />
      <TabsContainer>
        <Tabs tabList={tabList} />
      </TabsContainer>
    </SafeView>
  );
};

export default CloudInstanceDetails;
